import React from "react";
import { MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <Select
      value={i18n.language}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      size="small"
      sx={{ ml: 2, color: "white", borderColor: "white" }}
    >
      <MenuItem value="de">DE</MenuItem>
      <MenuItem value="en">EN</MenuItem>
    </Select>
  );
};

export default LanguageSwitcher;
